"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalDialog = void 0;
const HtmlWidget_1 = require("../../views/widgets/HtmlWidget");
class ModalDialog {
    constructor(parentContainer) {
        this.parentContainer = parentContainer;
        this.preventClickToExit = false;
        this.detachOnceClosed = true;
        this.modalContainer = document.createElement("div");
        this.modalContainer.classList.add("modal");
        let modalContent = document.createElement("div");
        modalContent.classList.add("modal-content");
        this.modalHeading = new HtmlWidget_1.HtmlWidget("div", "");
        this.modalHeading.renderBody.classList.add("modal-heading");
        this.modalHeading.shouldAppendChild = true;
        modalContent.appendChild(this.modalHeading.renderBody);
        this.modalBody = new HtmlWidget_1.HtmlWidget("div", "");
        this.modalBody.shouldAppendChild = true;
        this.modalBody.renderBody.classList.add("modal-body");
        modalContent.appendChild(this.modalBody.renderBody);
        this.modalFooter = new HtmlWidget_1.HtmlWidget("div", "");
        this.modalFooter.shouldAppendChild = true;
        this.modalFooter.renderBody.classList.add("modal-footer");
        modalContent.appendChild(this.modalFooter.renderBody);
        this.modalContainer.appendChild(modalContent);
        if (!this.detachOnceClosed) {
            parentContainer.appendChild(this.modalContainer);
        }
    }
    showDialog() {
        if (this.detachOnceClosed) {
            this.parentContainer.appendChild(this.modalContainer);
        }
        this.modalContainer.style.display = "block";
        window.onclick = (event) => {
            if (event.target === this.modalContainer) {
                if (!this.preventClickToExit) {
                    this.close();
                }
            }
        };
    }
    close() {
        this.modalContainer.style.display = "none";
        if (this.detachOnceClosed) {
            this.parentContainer.removeChild(this.modalContainer);
        }
    }
}
exports.ModalDialog = ModalDialog;
//# sourceMappingURL=ModalDialog.js.map